import React from 'react';

export default function LeaveBalanceSummaryCards({ summary }) {
  const cards = [
    {
      label: 'Total Entitled (Opening)',
      value: summary?.totalOpening || '36.00',
      unit: 'Days',
      icon: 'calendar_month',
      color: 'text-primary',
      bg: 'bg-primary/10',
    },
    {
      label: 'Leaves Consumed',
      value: summary?.totalConsume || '3.00',
      unit: 'Days',
      icon: 'event_busy',
      color: 'text-amber-600',
      bg: 'bg-amber-500/10',
    },
    {
      label: 'Lapsed Balance',
      value: summary?.totalLaps || '0.00',
      unit: 'Days',
      icon: 'history_toggle_off',
      color: 'text-slate-600',
      bg: 'bg-slate-500/10',
    },
    {
      label: 'Net Available Balance',
      value: summary?.totalCurrent || '33.00',
      unit: 'Days',
      icon: 'verified',
      color: 'text-emerald-600',
      bg: 'bg-emerald-500/10',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, index) => (
        <div
          key={index}
          className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest p-5 shadow-xs transition-all hover:shadow-sm"
        >
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-slate-600 uppercase tracking-wider">
              {card.label}
            </span>
            <div className={`flex h-9 w-9 items-center justify-center rounded-xl ${card.bg} ${card.color}`}>
              <span className="material-symbols-outlined text-lg">{card.icon}</span>
            </div>
          </div>
          <div className="mt-3 flex items-baseline gap-1.5">
            <span className="font-sans text-2xl font-extrabold text-on-surface tabular-nums tracking-tight">
              {card.value}
            </span>
            <span className="text-xs font-semibold text-slate-500">{card.unit}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
